import { DataPrivacyManager } from './DataPrivacyManager';
export function initializeDataPrivacyManager() {
    if (typeof globalThis !== 'undefined') {
        globalThis.DATA_PRIVACY_MANAGER =
            DataPrivacyManager.getInstance();
    }
    globalThis.DATA_PRIVACY_MANAGER?.initialize();
}
